module.exports = __webpack_public_path__ + "static/media/Style_Tilts.84538d2d.png";